const noop = () => null;
const dummyStorage = {
    getItem: () => null,
    setItem: noop,
    removeItem: noop,
};
export function getStorageObject() {
    return typeof window !== 'undefined' ? window.localStorage : dummyStorage;
}
